import React from "react";
import { useTranslation } from "react-i18next";
import { usePointsInfo } from "../../context/PointsInfoContext";

export default function EmployeeScoreCard({ points }) {
  const { t } = useTranslation(["common"]);
  const { openPointsInfo } = usePointsInfo();

  return (
    <div className="emp-score-card card-style">
      <div className="d-flex align-items-start justify-content-between">
        <span className="font_31 fas fa-star fa-fw mb-2 font-color-gold"></span>
        <button
          type="button"
          className="emp-score-card__info-btn"
          onClick={(e) => openPointsInfo(e)}
          aria-label={t("pointsInfoTitle")}
        >
          <i className="fas fa-info-circle"></i>
        </button>
      </div>
      <h1 className="font_16 font-bold mb-2">
        <span className="font_24 font-extrabold">{points}</span> {t("points")}
      </h1>
      <button
        type="button"
        className="emp-score-card__want-more font_16 font-color-grey"
        onClick={(e) => openPointsInfo(e)}
      >
        {t("wantMorePoints")}
      </button>
    </div>
  );
}
